var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TableControllerApiFactory } from "@/apis/table-management";
import { ArrowChevronIcon } from "@/components/Icons";
import StickyDrawer from "@/components/StickyDrawer";
import { LocalStorageKeys } from "@/constants/localStorage";
import useApi from "@/hooks/useApi";
import { theme, Typography } from "@atom/ui-kit";
import { Space } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import TransactionDetailInfo from "./_components/TransactionDetailInfo";
var TransactionDetailDrawer = function (_a) {
    var trigger = _a.trigger, data = _a.data, tableData = _a.tableData, props = __rest(_a, ["trigger", "data", "tableData"]);
    var t = useTranslation().t;
    var _b = useState(false), drawerVisible = _b[0], setDrawerVisible = _b[1];
    var _c = useApi({
        asyncFunction: TableControllerApiFactory().tablesTenantTenantIdIdGet,
        showErrorMessage: false,
    }), call = _c.call, tableRequestData = _c.data;
    useEffect(function () {
        if (!tableData && drawerVisible) {
            call({ id: data === null || data === void 0 ? void 0 : data.tableId, tenant: localStorage.getItem(LocalStorageKeys.TENANT) });
        }
    }, [data === null || data === void 0 ? void 0 : data.tableId, drawerVisible]);
    return (_jsxs(StickyDrawer, __assign({ trigger: trigger, width: "65%", open: drawerVisible, onClose: function () { return setDrawerVisible(false); }, onOpen: function () { return setDrawerVisible(true); } }, props, { children: [_jsxs(Space, { style: { marginBottom: 20 }, children: [_jsx(ArrowChevronIcon, { style: { cursor: "pointer" }, onClick: function () { return setDrawerVisible(false); } }), _jsxs(Typography.Title, { color: theme.colors.PrimaryDefault, level: 4, children: [" ", (data === null || data === void 0 ? void 0 : data.name) + " " + t("transactionManagement.detailDrawer.roundTransactions.title")] })] }), _jsx(TransactionDetailInfo, { tableData: tableData || (tableRequestData === null || tableRequestData === void 0 ? void 0 : tableRequestData.data), t: t, gameData: data })] })));
};
export default TransactionDetailDrawer;
